import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import ObtenerPlanes from '../functions/ObtenerPlanes';
import PlanTabla from '../types/PlanTabla';


interface ListarPlanesProps {
    defaultItemsPerPage?: number;
    handleEditPlan: (plan: PlanTabla) => void;
    handleDeletePlan: (plan: PlanTabla) => void;
    handleAddPlan: () => void;
}

export const ListarPlanes: React.FC<ListarPlanesProps> = ({ defaultItemsPerPage = 15, handleEditPlan, handleDeletePlan, handleAddPlan, }) => {
  
  const [planes, setPlanes] = useState<PlanTabla[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  const handleMostrarCredencial = (plan: PlanTabla) => {
    console.log('Mostrar credencial', plan);
  };

  const handleUbication = (plan: PlanTabla) => {
    console.log('Mostrar ubicacion', plan);
  };
  
  useEffect(() => {
    const fetchPlanes = async () => {
      try {
        const data = await ObtenerPlanes();
        setPlanes(data.planes);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener los planes');
        setLoading(false);
      }
    };

    fetchPlanes();
  }, []);

  /*
  id: number;
  title: string;
  price: number;
  pricedebito: number;
  habilitado: string;
  dado_de_baja: string;
  codigoplan: string;
  pago_online: string;

  */
  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'title', label: 'DESCRIPCION', align: 'left' as const },
    { key: 'price', label: 'IMPORTE', align: 'right' as const },
    { key: 'pricedebito', label: 'IMPORTE DEBITO', align: 'right' as const },
    { key: 'mostrar', label: 'MOSTRAR', align: 'center' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'dado_de_baja', label: 'DADO DE BAJA', align: 'center' as const },
    { key: 'codigoplan', label: 'CODIGO PLAN', align: 'center' as const },
    { key: 'pago_online', label: 'PAGO ONLINE', align: 'center' as const },
  ];

  const handleEdit = (plan: PlanTabla) => {
    handleEditPlan(plan);
  };

  const handleDelete = (plan: PlanTabla) => {
    handleDeletePlan(plan);
  };


  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Planes cargados</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAddPlan}>Nuevo Plan</button>
        </div>
      </div>
      <Tabla columns={columns} data={planes} onEdit={handleEdit} onDelete={handleDelete} itemsPerPage={itemsPerPage} onCredencial={handleMostrarCredencial} onUbication={handleUbication} acciones={['editar','eliminar']}/>
    </div>
  );
};